module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Prologue"
    }
  }, [_c('p', {
    staticClass: "ch-num"
  }, [_vm._v("P R O L O G U E"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page9"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ch-title"
  }, [_vm._v("16 March 1917")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("It was St Patrick’s Eve. The sky was a mass of dull, pewtered grey: dark, lowering, and ominous. The constant stratus cloud was moving briskly to the northwest under the influence of a strong southeasterly wind. It was raining with a cold, biting determination broken only by the occasional resort to snow in squalls, blotting out the limited visibility. To the west lay the Shetland Islands, wind and storm tossed in unending winter; to the east Norway, with its ice and snow; and in between, a ship.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The ship was burning. A tall pall of smoke, bent over itself by the wind, hung over her. Jets of flame shot up through the plume, fierce orange, red and gold coloured against the gunmetal sky, like a Turner sunset in one of his late impressionistic masterpieces. The fore part of her hull was glowing red with inner heat, while oil poured from her ruptured tanks and settled around her, catching fire in places. She was Wagnerian, dying, a "), _c('i', [_vm._v("Götterdämmerung")]), _vm._v(" of steel and flame.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Over the vessel flew a Norwegian flag, red with a white-outlined Scandinavian cross. From her stern came the stilted popping of gunfire, the muzzle flash lost in the greater inferno of her immolation.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It was 1632 Greenwich Mean Time. One minute later the blazing ship rolled over onto her port side, exposing a clean, unfouled bottom and in a frenzy of roiled water, steam and fire sank down to the bed of the icy sea. Not one of the 325 men on board survived.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She was "), _c('i', [_vm._v("Yarrowdale")]), _vm._v("; she was "), _c('i', [_vm._v("Rena")]), _vm._v("; she was "), _c('i', [_vm._v("Leopard")]), _vm._v("."), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page10"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-318aecef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_Prologue.vue
// module id = 81
// module chunks = 0